import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchSegments = createAction(constants.FETCH_SEGMENTS)
export const fetchSegmentsPending = createAction(constants.FETCH_SEGMENTS_PENDING)
export const fetchSegmentsFailed = createAction(constants.FETCH_SEGMENTS_FAILED)
export const fetchSegmentsSuccess = createAction(constants.FETCH_SEGMENTS_SUCCESS)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/endUser/segment/actions.js